import * as React from "react";
import { PaymentField } from "./PaymentField";
import Label from './Label'
import {DOMAttributes} from "react";

class TextField extends React.Component<PaymentField & DOMAttributes<HTMLInputElement>, any> {
  private cannotBeBlank = 'Cannot be blank';

  constructor(props: PaymentField){
    super(props);
    let defaultError = this.props.error || (this.props.required ? this.cannotBeBlank : '');
    this.state = { message: defaultError, showErrors: false };
  }
  
  private checkMaxLength = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if(!this.props.maxLength) return;
    let totalLength = event.currentTarget.value.length + ((event.key.length > 1) ? -1 : 1);
    const message = (totalLength > this.props.maxLength) ? `Length may not exceed ${this.props.maxLength}` : '';
    this.setState({ message: message, showErrors: true });
  };

  private onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    let target = event.currentTarget;
    if(this.props.format) {
      target.value = this.props.format(target.value);
    }

    target.setCustomValidity(this.validate(target.value));
  };

  private validate = (value: string) => {
    let message: string | undefined = '';
    if(this.props.validation) message = this.props.validation!.test(value) ? '' : this.props.error;

    if(this.props.required && value.trim().length == 0) message = 'Cannot be blank';
    this.setState({ message: message, showErrors: true });
    return message || '';
  };

  public render() {
    const { format, ...other } = this.props;
    return (
      <div className={this.props.tag}>
        <Label htmlFor={this.props.field} showErrors={this.state.showErrors} error={this.state.message}>
            {this.props.label}
        </Label>
        <input
          type="text"
          onInvalid={()=> { this.setState({ showErrors: true}); }}
          onBlur={this.onBlur}
          onKeyDown={this.checkMaxLength}
          id={this.props.field}
          name={this.props.field}
          {...other}
          />
      </div>
    );
  }
}

export default TextField;



// WEBPACK FOOTER //
// ./src/checkout/fields/TextField.tsx